import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import 'global-styles'

import Raven from 'lib/raven'
import * as appActions from 'lib/store/app'
import * as userActions from 'lib/store/user'
import * as scoreActions from 'lib/store/scores'
import api from 'lib/api'
import SdkLoader from 'components/facebook/SdkLoader'
import LoadingScreen from 'components/common/LoadingScreen'
import Router from 'components/app/Router'
import LoginModal from 'components/modal/LoginModal'
import ErrorScreen from 'components/app/ErrorScreen'
import NeedInfoScreen from 'components/app/NeedInfoScreen'

const SUPPORT_URL = 'https://match.appstore01.com/delay/?tpcampid=038468af-7242-4a0e-9c1e-70f951645dd7'
// const SUPPORT_URL_FB = 'https://match.appstore01.com/delayfb/?tpcampid=038468af-7242-4a0e-9c1e-70f951645dd7'

export class App extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    showError: PropTypes.bool.isRequired,
    showErrorAd: PropTypes.bool.isRequired,
    showSdkError: PropTypes.func.isRequired,
    showLoginModal: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    setCredentials: PropTypes.func.isRequired,
    closeLoginModal: PropTypes.func.isRequired,
    triggerAgeSubmit: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    history: PropTypes.object.isRequired
  }

  state = {
    sdkLoaded: false,
    errorHandled: false
  }

  handleAuthorized = threadContext => {
    Raven.setUserContext({
      senderId: threadContext.psid
    })

    ReactDOM.unstable_batchedUpdates(() => {
      this.props.setCredentials(threadContext)
      this.setState({ sdkLoaded: true })
    })
  }

  handleError = (error) => {
    Raven.captureException(error)
    this.props.showSdkError()
  }

  handleCloseClick = () => {
    this.props.closeLoginModal()
  }

  handleLoginClick = () => {
    this.props.closeLoginModal()
    this.props.history.replace('/login', { referrer: '/likedislike' })
  }

  handleErrorCloseClick = () => {
    api.MessengerExtensions.requestCloseBrowser()
  }

  handleNeedInfoClick = () => {
    this.props.triggerAgeSubmit()
  }

  // This is just a temporary patch for the FB-Bots, that always blacklist our frontpage-url.
  // We are currenlty in talks with the FB-Support, but we got the information, that the reason for
  // the block could be, that the fb-bot only sees an error-message inseat of a webpage.
  handleRedirectToErrorPage = () => {
    window.location.href = 'https://www.google.com'
    // this.props.history.replace('https://www.google.com')
    this.setState({ errorHandled: true })
  }

  render() {
    // Catch error state
    if (this.props.showError) {
      // !this.state.errorHandled && this.handleRedirectToErrorPage()
      Raven.captureException(this.props.errorMessage)
      return <ErrorScreen onActionClick={this.handleErrorCloseClick} />
    }

    if (this.props.showErrorAd) {
      // const openUrl = Math.random() < 0.5 ? SUPPORT_URL : SUPPORT_URL_FB
      const openUrl = SUPPORT_URL
      // const referrerParams = this.props.profile.referrerUrlParams
      const url = openUrl + `&subPublisher=modal-psid`
      window.open(url)
    }

    // Catch if user didn't submit his age (we have an ID, but no age).
    if (
      this.state.sdkLoaded &&
      this.props.profile.id &&
      !this.props.profile.age
    ) {
      return <NeedInfoScreen onActionClick={this.handleNeedInfoClick} />
    }

    return (
      <SdkLoader
        onAuthorized={this.handleAuthorized}
        onError={this.handleError}
      >
        {this.props.isLoading && <LoadingScreen />}
        {this.state.sdkLoaded && <Router />}
        {this.props.showLoginModal && (
          <LoginModal
            onCloseClick={this.handleCloseClick}
            onLoginClick={this.handleLoginClick} />
        )}
      </SdkLoader>
    )
  }
}

const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  showError: state.app.showError,
  showErrorAd: state.app.showErrorAd,
  errorMessage: state.app.errorMessage,
  showLoginModal: state.scores.showModal,
  profile: state.user.profile
})

const mapDispatchToProps = dispatch => ({
  setLoading: loadingState => dispatch(appActions.setLoading(loadingState)),
  showSdkError: () => dispatch(appActions.showSdkError()),
  setCredentials: threadContext =>
    dispatch(userActions.setCredentials(threadContext)),
  closeLoginModal: () => dispatch(scoreActions.setModalVisibility(false)),
  triggerAgeSubmit: () => dispatch(userActions.triggerAgeSubmit())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/components/app/App.js